//
// DataGridColumnInfo.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";
import "../BaseUIModel";
import "./CellVisualType";
import "./CellVisualPosition";
import "../../styles/AttributeBundle";
import "./CompactFormatOptions";
import "../../rules/interfaces/Rule";
import "../data/sorting/SortDirection";
import "./ColumnContentType";

var DataGridColumnInfo = createModule("commons_DataGridColumnInfo", [130,13,10004,10022], EventDispatcher, [
    ,
    {
        cellVisual: 4,
        totalVisible: 2,
        compactFormatOptions: 1,
        presentationLabel: 7,
        cellVisualPosition: 4,
        columnType: 4,
        sortDirection: 4,
        cellVisualMissingColor: 10,
        displayRule: 1,
        styleClassName: 7,
        sparkKPI: 2,
        cellVisualStyleAttributes: 1,
        header: 2,
        columnWidth: 4,
        columnIndex: 4,
        cellVisualFillColor: 10,
        useCompactFormat: 2,
        compactFormatName: 7,
        interactiveHeader: 2,
        sparkLine: 2,
        primarySortApplied: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataGridColumnInfo;
